import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { OptionList, OptionListHeight } from '../OptionList';

import { SoundTracksListProps } from './SoundTrackList.types';

export const SoundTracksList: FC<SoundTracksListProps> = ({
    className,
    titleClassName,
    currentSoundTrack,
    soundTracksWithNotes,
    handleSelectSoundTrack,
}) => (
    <section className={className}>
        <h1 className={titleClassName}>
            <FormattedMessage
                id="components.PlayerSkin.9d07e0e08af7f96cf45be0112b9ccfbe"
                defaultMessage="Sound"
                description="Текст заголовка 'Звук' в плеере"
            />
        </h1>
        <div>
            <OptionList<string>
                value={currentSoundTrack || null}
                onSelect={handleSelectSoundTrack}
                options={soundTracksWithNotes}
                heightType={OptionListHeight.Range}
            />
        </div>
    </section>
);
